export interface Project {
  id: number;
  name: string;
  year: string;
  location: string;
  image: string;
}

export const projects: Project[] = [
  {
    id: 3,
    name: "Escola EB Gaf. Encarnação N",
    year: "2025",
    location: "Paulo Valente arquitetura",
    image: "https://static.readdy.ai/image/413ccbf5fb2d9cba47392df0340806cc/240c314a6dade0203c152e5f8d6d6478.png"
  },
  {
    id: 2,
    name: "Habitação RD",
    year: "2026",
    location: "Paulo Valente arquitetura",
    image: "https://static.readdy.ai/image/413ccbf5fb2d9cba47392df0340806cc/8bf9b5a23dc24b5a58b995275d907690.png"
  },
  {
    id: 4,
    name: "Cafetaria Mata do Bussaco",
    year: "2020",
    location: "Paulo Valente arquitetura",
    image: "https://static.readdy.ai/image/413ccbf5fb2d9cba47392df0340806cc/8b136382b7b5a2ec107e8a99a9c1dab4.png"
  },
  {
    id: 5,
    name: "Habitação AC",
    year: "2025",
    location: "Paulo Valente arquitetura",
    image: "https://static.readdy.ai/image/413ccbf5fb2d9cba47392df0340806cc/9adf712cdd0d7a4cf7f9325bbac0abfb.png"
  },
  {
    id: 13,
    name: "Habitação RD",
    year: "2026",
    location: "Paulo Valente arquitetura",
    image: "https://static.readdy.ai/image/413ccbf5fb2d9cba47392df0340806cc/425f5aa6d77de6a786e069ccb5b29c42.png"
  },
  {
    id: 15,
    name: "Habitação unifamiliar",
    year: "2025",
    location: "Ensaio atelier",
    image: "https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/b7987002-b58d-4843-a7ec-9c6790b7f125_2k_Final_EXT_PTIO-1.png?v=fd205b93d0c87f5ff83855be0ad84a8f"
  },
  {
    id: 11,
    name: "Edifício de Habitação Multifamiliar",
    year: "2024",
    location: "RF arquitetura",
    image: "https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/14f31e10-c1c5-4108-b085-938dd96fd4d9_7.png?v=e263ce5128af654d1f15ec57ca7568a0"
  },
  {
    id: 1,
    name: "Habitação MS",
    year: "2023",
    location: "Paulo Valente arquitetura",
    image: "https://static.readdy.ai/image/413ccbf5fb2d9cba47392df0340806cc/0347cbfce458309cbed953e0f5c750f9.png"
  },
  {
    id: 12,
    name: "Cafetaria Mata do Bussaco",
    year: "2024",
    location: "Paulo Valente arquitetura",
    image: "https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/4e74c1dc-11f8-454e-adc4-eec34baa91a2_10.png?v=6dac30a4b0635b387d74e3404a3a1a4d"
  },
  {
    id: 8,
    name: "Casa do Telheiro",
    year: "2025",
    location: "Habiclasse",
    image: "https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/3b3a65cf-df4c-4503-ab4a-f256c9822276_3.png?v=636dc0195b0f971a5a06cd950ea00abb"
  },
  {
    id: 9,
    name: "Casa do Telheiro",
    year: "2025",
    location: "Habiclasse",
    image: "https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/de3ec225-c1c0-4f1b-87fd-2f11062dcbff_4.png?v=0b0f76db0e3bb3d417a80abd1fe6ea65"
  },
  {
    id: 6,
    name: "Habitação RD",
    year: "2026",
    location: "Paulo Valente arquitetura",
    image: "https://static.readdy.ai/image/413ccbf5fb2d9cba47392df0340806cc/642e38704eeca429009fcd61d4a8b759.png"
  },
  {
    id: 14,
    name: "Habitação AC",
    year: "2024",
    location: "Paulo Valente arquitetura",
    image: "https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/8d231da8-9cc0-4157-b86d-b45ca5e465a1_13.png?v=151619d3304e6e7ab71f0aca264b5a2f"
  },
  {
    id: 10,
    name: "Habitação NS",
    year: "2024",
    location: "Paulo Valente arquitetura",
    image: "https://storage.readdy-site.link/project_files/7132ca6f-5f51-4f09-ac5f-77e8f75938d4/2a4ad59f-e23f-4674-bb24-abe35c349e10_6.png?v=dd370e0a2fa21d5e404a063ae907dbe8"
  }
];
